import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/U2-T1-1-9a.svg'

const data = [
  {
    inputType: 'radio',
    question: 'Vaping liquid includes addictive nicotine.',
    options: [
      {
        label: 'True',
      },
      {
        label: 'False',
      },
    ],
  },
]

const correctInput = {
  [data[0].question]: 'True',
}

const feedback = {
  success: {
    title: 'You Are Correct!',
    body:
      'Vaping liquid includes the same addictive nicotine as regular cigarettes.',
  },
  error: {
    title: "That's Incorect.",
    body:
      'Vaping liquid includes the same addictive nicotine as regular cigarettes.',
  },
}

export default {
  title: 'Question 2',
  path: '/learn/question-2',
  content: (
    <Fragment>
      <Intro
        title="True or False?"
        lead="Before you move on to the post-test questions, let’s check your understanding of what you’ve learned in the module!"
        direction="Select the best answer."
        img={image}
      />
      <MultipleChoice
        data={data}
        feedback={feedback}
        correctInput={correctInput}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Learn/Question2.js